import { SimpleTable } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit, TableActionContainer } from '@core/components/TableAction';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatCPF, formatTELEFONE } from '@format';
import React, { useContext } from 'react';
import { ClienteContext } from '../../ClienteContext';
import ClienteFab from '../ClienteFab';
import { clienteModais } from '../modal/clienteModais';

const ClienteTable = ({ onSelection, fetchCliente, fetchClientes, onDelete, onTour }) => {
  const [clientes] = useContext(ClienteContext).clientes;
  const [selecao] = useContext(ClienteContext).selecao;
  const [loading] = useContext(ClienteContext).loading;
  const [, setModal] = useContext(ClienteContext).modal;
  const [totalElements] = useContext(ClienteContext).totalElements;
  const [search] = useContext(ClienteContext).search;
  const [, setPage] = useContext(ClienteContext).page;
  const [, setSize] = useContext(ClienteContext).size;
  const [, setSort] = useContext(ClienteContext).sort;
  const [tipoSelecao, setTipoSelecao] = useContext(ClienteContext).tipoSelecao;
  const [filtroAvancado] = useContext(ClienteContext).filtroAvancado;

  const handleOpenModalVisualizar = async (cliente) => {
    await fetchCliente(cliente.id);
    setModal(clienteModais.visualizacaoCliente);
  };

  const handleOpenModalEditar = async (cliente) => {
    await fetchCliente(cliente.id);
    setModal(clienteModais.cadastroCliente);
  };

  const clienteColumnDefs = [
    {
      title: 'Nome',
      name: 'pessoa.nome',
      sortingEnabled: true,
      getCellValue: (cliente) => {
        return cliente.nome;
      },
    },
    {
      title: 'Razão social',
      name: 'pessoa.pessoaJuridica.razaoSocial',
      sortingEnabled: true,
      getCellValue: (cliente) => {
        return cliente.razaoSocial;
      },
    },
    {
      title: 'CPF/CNPJ',
      name: 'pessoa.cpfCnpj',
      sortingEnabled: true,
      hideTooltip: true,
      getCellValue: (cliente) => {
        if (cliente.cpf) {
          return formatCPF(cliente.cpf);
        }
        if (cliente.cnpj) {
          return formatCNPJ(cliente.cnpj);
        }
      },
    },
    {
      title: 'Telefone principal',
      name: 'pessoa.contatos.numero',
      sortingEnabled: true,
      hideTooltip: true,
      getCellValue: (cliente) => {
        if (cliente.telefonePrincipal) {
          return cliente.codigoPais
            ? `${cliente.codigoPais} ${formatTELEFONE(cliente.telefonePrincipal)}`
            : formatTELEFONE(cliente.telefonePrincipal);
        }
      },
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (cliente) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.cliente().editar && (
              <TableActionButtonEdit className={'stepIconeEditar'} onClick={() => handleOpenModalEditar(cliente)} />
            )}

            {permissaoUtils.cliente().excluir && (
              <TableActionButtonDelete
                className={'stepIconeExcluir'}
                onClick={() => onDelete({ ids: [cliente], q: search, tipoSelecao: 'NENHUM' })}
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  return (
    <>
      <SimpleTable
        getRowId={(row) => row}
        columns={clienteColumnDefs}
        rows={clientes}
        fetchData={fetchClientes}
        loading={loading}
        onRowClick={handleOpenModalVisualizar}
        defaultSorting={[{ columnName: 'pessoa.nome', direction: 'asc' }]}
        totalCount={totalElements}
        onCurrentPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(params) => {
          setSize(params);
        }}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(tipo) => {
          setTipoSelecao(tipo);
        }}
        selection={selecao}
        onSelectionChange={onSelection}
        onSortingChange={(params) => setSort(params)}
        onLoadingChange={() => {}}
        searchBy={search}
        params={filtroAvancado}
        contemFiltroAvancado
      />
      {(permissaoUtils.cliente().cadastrar || permissaoUtils.cliente().excluir) && (
        <ClienteFab selected={selecao.length} onDelete={onDelete} fetchCliente={fetchCliente} />
      )}
    </>
  );
};

export default ClienteTable;
